import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import User from "../model/User";
import { RootState } from "./store";

const initialState: User = {
    uid: "",
    email: "",
    name: "",
    image: "",
    is_login: false
};

export const userSlice = createSlice({
    name: 'userReducer',
    initialState,
    reducers: {
        setUserLogin: (state, action: PayloadAction<any>) => {
            return {
                ...state,
                uid: action.payload.uid,
                email: action.payload.email,
                name: action.payload.name,
                image: action.payload.image,
                is_login: true
            }
        },
        setUserLogout: state => {
            return {
                ...initialState
            }
        },
    }
})

export const selectuser = (rootState: RootState) => rootState.user;
export const selectUserIsLogin = (rootState: RootState) => selectuser(rootState).is_login;
export const { setUserLogin, setUserLogout } = userSlice.actions;
export default userSlice.reducer;